<template>
  <div>
    <el-button
      v-if="$attrs.row[$attrs.column] != '404'"
      class="parpadea md-raised md-danger"
      type="submit"
      @click="modalValoration()"
      style="
        background-color: #f66407;
        color: white;
        border-radius: 20px;
        box-shadow: 1px 2px #888888;
      "
      ><i class="el-icon-view"></i>
    </el-button>

    <!-- DIALOGO SOLICITUDES PENDIENTE POR CALIFICAR -->
    <el-dialog
      title="¿Cómo Califica la calidad del servicio brindado?"
      :visible.sync="QualifyFormVisible"
      width="25%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="false"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <div class="row">
                <div class="rate" style="margin-left: 54px">
                  <input
                    type="radio"
                    id="star5"
                    name="rate"
                    value="5"
                    @click="clickme(5)"
                  />
                  <label
                    for="star5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="EXCELENTE"
                    style="font-size: 40px"
                    >5 stars</label
                  >
                  <input
                    type="radio"
                    id="star4"
                    name="rate"
                    value="4"
                    @click="clickme(4)"
                  />
                  <label
                    for="star4"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="BUENO"
                    style="font-size: 40px"
                    >4 stars</label
                  >
                  <input
                    type="radio"
                    id="star3"
                    name="rate"
                    value="3"
                    @click="clickme(3)"
                  />
                  <label
                    for="star3"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="REGULAR"
                    style="font-size: 40px"
                    >3 stars</label
                  >
                  <input
                    type="radio"
                    id="star2"
                    name="rate"
                    value="2"
                    @click="clickme(2)"
                  />
                  <label
                    for="star2"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="DEFICIENTE"
                    style="font-size: 40px"
                    >2 stars</label
                  >
                  <input
                    type="radio"
                    id="star1"
                    name="rate"
                    value="1"
                    @click="clickme(1)"
                  />
                  <label
                    for="star1"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="MALO"
                    style="font-size: 40px"
                    >1 star</label
                  >
                </div>
              </div>
              <br />

              <label
                id="lblcoment"
                style="font-size: 22px; color: #019ffd; float: left"
                hidden
              >
                ¿Qué nos faltó para que califique nuesto servicio como
                excelente?
              </label>
              <div class="row" id="dvcoment" hidden>
                <div class="col-md-12">
                  <el-input
                    type="textarea"
                    v-model="comments"
                    rows="4"
                    cols="70"
                    style="margin-bottom: 10px; width: 100%"
                    id="comentario"
                  >
                  </el-input>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="container text-center">
                  <el-button
                    class="md-raised md-danger"
                    type="submit"
                    @click="SendValorations($attrs.row)"
                    style="
                      background-color: #019ffd;
                      color: white;
                      font-size: 20px;
                    "
                    :loading="loading"
                    >Enviar calificación
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QualifyServiceRequest",
  data: () => ({
    file: "",
    files: "",
    QualifyFormVisible: false,
    startNumber: 0,
    comments: "",
    model: {
      solicitudid: null,
      valoracion: null,
      comentario: null,
      clientCode: null,
      CompanyCode: null,
      ComplaintId: null
    },
    loading: false
  }),
  methods: {
    modalValoration() {
      this.QualifyFormVisible = true;
    },
    clickme(val) {
      //console.log('CALIFICADO CON -->', val)
      this.startNumber = val;
      if (val != 5) {
        document.getElementById("lblcoment").removeAttribute("hidden");
        document.getElementById("dvcoment").removeAttribute("hidden");
      } else {
        document.getElementById("lblcoment").setAttribute("hidden", "hidden");
        document.getElementById("dvcoment").setAttribute("hidden", "hidden");
      }
    },
    SendValorations(val) {
      this.model.valoracion = this.startNumber;
      this.model.comentario = this.comments;
      this.model.solicitudid = val.serviceRequestID;
      this.model.clientCode = val.ClientCode;
      this.model.CompanyCode = this.currentCompany;

      this.loading = true;
      this.$http
        .post("/api/serviceRequests/RegisterQualify", this.model)
        .then((resp) => {
          const { data: isSuccess } = resp;
          if (isSuccess) {
            this.QualifyFormVisible = false;
            this.$message.success("Calificacion exitosa");
            this.$emit("rating-success");
          } else {
            this.$message.warning("Algo salio mal");
          }
        })
        .catch((error) => {
          this.QualifyFormVisible = false;
          console.error(error);
          this.$message.error("Error al calificar esta solicitud");
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.rate {
  float: left;
  height: 46px;
  padding: 0 10px;
}

.rate:not(:checked) > input {
  position: absolute;
  top: -9999px;
}

.rate:not(:checked) > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 30px;
  color: #ccc;
}

.rate:not(:checked) > label:before {
  content: "★ ";
}

.rate > input:checked ~ label {
  color: #ffc700;
}

.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
  color: #deb217;
}

.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  color: #c59b08;
}

.text {
  font-size: 20px;
  font-family: helvetica;
  font-weight: bold;
  background-color: #aba8a8;
  text-transform: uppercase;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  -webkit-animation-name: parpadeo;
  -webkit-animation-duration: 4s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}
@-moz-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
